import { Behavior } from "./Behavior";
import { Component } from "./Component";

export class ComponentTooltipHandlerBehavior extends Behavior {
    protected constructor() {
        super();
    }

    public shouldPreventTooltipDisplay(component: Component): boolean {
        return component._designer != null && component.tooltipDynamicDesignerContent == null;
    }

    get type(): string {
        return "ComponentTooltipHandler";
    }
}

ComponentTooltipHandlerBehavior.register();
